import Shape from './Shape';
import BannerFrame from './BannerFrame.js';
import ApplicationFrame from './ApplicationFrame.js';
import NewsFrame from './NewsFrame.js';
import FloorFrame from './FloorFrame.js';

module.exports = {
  Shape,
  BannerFrame,
  ApplicationFrame,
  NewsFrame,
  FloorFrame
};



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/index.js